import { Raycaster } from 'three';

export class SceneUtils {
  public static raycaster = new Raycaster();
}
